import React, { useContext } from 'react';
import styles from './escalatePageHeader.module.css';
import { ColumnConfig } from '../columnConfig/columnConfig.index';
import { EscalationMetric } from './components/escalationMetric/escalationMetric.index';
import { EscalationFilterShowcase } from './components/escalationMetric/components/filterShowcase/escalationFilterShowcase.index';
import { EscalatePageHeaderProps } from './escalatedPageHeader.models';
import { buildPayload } from './escalatedPageHeader.utils';
import SearchBar from '../../../../Components/inputTypes/searchBar/searchBar';
import { useEscalatedDataFetch } from '../../escalatedPage.hooks';
import { useEscalationInfo } from '../../../../Context/escalationContext';
import { UserContext, UserPayload } from '../../../../Context/userContext';

export const EscalatePageHeader = ({
    headerNames,
    fixedColumns,
    visibleColumns,
    setVisibleColumns,
    appliedFilters,
    setAppliedFilters,
}: EscalatePageHeaderProps) => {
    const { searchValue, setSearchValue, paginationDetail, setPaginationDetail, sortInfo } =
        useEscalationInfo();
    const { showLoader } = useContext(UserContext) as UserPayload;
    const { fetchEscalatedData } = useEscalatedDataFetch();

    const OnSearchHandler = (value: string) => {
        const nextSearchParam = value || null;

        if (nextSearchParam === searchValue || showLoader) {
            return;
        }

        setSearchValue(nextSearchParam);
        const payload = buildPayload({
            filters: appliedFilters,
            pageSize: paginationDetail.rowsPerPage,
            pageIndex: 1,
            searchParam: nextSearchParam,
            sort: sortInfo
        });
        setPaginationDetail((prevState) => ({
            ...prevState,
            page: 0,
        }));
        fetchEscalatedData(payload);
    }

    return (
        <div className={styles.escalatePageHeader}>
            <div className={styles.escalatePageHeaderLeft}>
                <EscalationMetric
                    appliedFilters={appliedFilters}
                    setAppliedFilters={setAppliedFilters}
                />
                <EscalationFilterShowcase
                    appliedFilters={appliedFilters}
                    setAppliedFilters={setAppliedFilters}
                />
            </div>

            <div className={styles.escalatePageHeaderRight}>
                <SearchBar
                    searchText={searchValue ?? ""}
                    onSearch={OnSearchHandler}
                    placeholder="Search"
                />
                <ColumnConfig
                    headerNames={headerNames}
                    fixedColumns={fixedColumns}
                    visibleColumns={visibleColumns}
                    setVisibleColumns={setVisibleColumns}
                />
            </div>
        </div>
    );
};